import { createContext } from "react";
import { DEFAULT_AUTH_DATA_CONTEXT } from "../constants";
export var AuthDataContext = createContext(DEFAULT_AUTH_DATA_CONTEXT);
